/**
 * Service for orchestrating rebooking processes
 * This file acts as the main coordination point for rebooking operations
 * Individual functionality has been moved to dedicated files for better maintainability
 */
import { useErrorStore } from '../../stores/errorStore'
import { fetchBookingData, revertBooking } from '../journeyService'
import { prepareRebookingRequest } from './rebookingRequestBuilder'
import { rebookJourney } from './rebookingExecutor'
import { hasProvisionalChanges } from '../../utils/rebooking/rebookingValidationUtils'

export const handleRebookingProcess = async (
  bookingNumber: string,
  selectedTravel: any,
  selectedReturnTravel: any | null,
  itemsToReplace: string[] = []
) => {
  const errorStore = useErrorStore()

  try {
    let response = await fetchBookingData(bookingNumber, true)
    let bookingData = response?.data?.booking

    if (bookingData) {
      if (hasProvisionalChanges(bookingData) && bookingData.booking_number) {
        await revertBooking(bookingData.booking_number)

        const updatedResponse = await fetchBookingData(bookingNumber, true)
        if (updatedResponse?.data?.booking) {
          bookingData = updatedResponse.data.booking
        }
      }
    }

    if (!bookingData) {
      throw new Error('No booking data available')
    }
    const apiRequest = await prepareRebookingRequest(
      bookingData,
      selectedTravel,
      selectedReturnTravel,
      itemsToReplace
    )

    return await rebookJourney(bookingNumber, apiRequest)
  } catch (error) {
    console.error('Error during rebooking process:', error)
    let errorMessage = 'Failed to rebook journey'

    if (error instanceof Error) {
      errorMessage = error.message || errorMessage
    }

    errorStore.setError(errorMessage)
    throw error
  }
}

export { prepareRebookingRequest } from './rebookingRequestBuilder'
export { rebookJourney } from './rebookingExecutor'
export { hasProvisionalChanges } from '../../utils/rebooking/rebookingValidationUtils'
